// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page-intro":"styles__page-intro___2RP1d","pageIntro":"styles__page-intro___2RP1d","intro-heading":"styles__intro-heading___5SzJ-","introHeading":"styles__intro-heading___5SzJ-","status-button":"styles__status-button___2B2H5","statusButton":"styles__status-button___2B2H5","intro-text":"styles__intro-text___1MK1M","introText":"styles__intro-text___1MK1M"};
    if(module.hot) {
      // 1695609767253
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  